import styled, { css } from "styled-components";

import PageWrapper from "Components/Pages/Wrapper";
import { Form } from "formik";

export const FormContainer = styled.form`
  display: flex;
  margin-top: 1rem;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 22px;
  row-gap: 20px;
  column-gap: 16px;

  .inputs-container {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .search-input {
    width: 100%;
    max-width: 300px;
  }

  select,
  input {
    border-radius: 8px;
    color: #b1b1b1;
    font-size: 13px;
    padding: 5px 16px;
  }

  .select-field-holder .arrow-icon {
    top: 8px;
    font-size: 15px;
    font-weight: 700;
  }

  .buttons-container {
    display: flex;
    gap: 16px;
    margin-right: auto;
  }
`;

export const CampFile = styled.div`
  margin-right: 22px;
  width: 100%;
  max-width: 250px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 96px;
  box-shadow: 0px 0px 0px 1px rgba(130, 136, 148, 0.16),
    0px 4px 6px -2px rgba(130, 136, 148, 0.32);
  border-radius: 24px;
  margin-bottom: 36px;
  padding: 0 30px;

  .space-file-name {
    display: flex;
    align-items: center;
    gap: 20px;
    padding-left: 23px;

    .img-add-page {
      padding: 0 25px;
    }
  }

  .button-trash {
    margin-right: 34px;
  }

  img {
    max-width: 74px;
    max-height: 96px;
  }

  &.addAnexo {
    margin-right: 0 !important;

    p {
      margin: 0;
    }
  }

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 168px;
  }
`;

export const CheckboxSublist = styled.div<{ height: number }>`
  ${({ height }) =>
    css`
      height: ${height ? `${height + 20}px` : "initial"};
    `};

  &.checkbox-units {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
`;

export const PageContainer = styled(PageWrapper)`
  &.entry-app-content {
    // padding-left: 60px;

    .content-holder {
      padding: 24px 20px;
    }

    .page-content {
      padding-top: 0;
      padding-right: 0;
      padding-left: 0;

      .table-content {
        border-radius: 15px 15px 0px 0px;
        thead th:first-child,
        thead th:last-child {
          border-radius: 0;
        }
      }

      .loader {
        display: flex;
        justify-content: center;
        margin-top: 50px;
      }
    }
  }

  @media (min-width: 1260px) {
    &.entry-app-content {
      padding-top: 0px;
      position: relative;
      padding-right: 0;
      // padding-left: 230px;
    }
  }
`;

export const Container = styled.div`
  &.entry-app-content {
    // padding-left: 60px;

    .content-holder {
      padding: 24px 20px;

      .wrapper-header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .buttons-container {
          display: flex;
          gap: 10px;
        }
      }

      main {
        margin-top: 23px;
        border-top: 1px solid #ebebeb;

        .form {
          margin-top: 20px;
          justify-content: center;
        }

        .error {
          margin-top: 150px;
          font-family: var(--font-display);
          font-style: normal;
          font-weight: normal;
          font-size: 1.25rem;
          line-height: 1.75rem;
          color: var(--color-purple);
          text-align: center;
        }

        .error-message {
          font-size: 10px;
          line-height: 14px;
          text-align: right;
          color: #c23f3b;
        }

        .error-position {
          position: absolute;
          bottom: 0;
          right: 10px;
        }
      }
    }
  }

  @media (min-width: 1260px) {
    &.entry-app-content {
      padding-top: 0px;
      position: relative;
      padding-right: 0;
      // padding-left: 230px;
    }
  }
`;

export const PartnerFormStyle = styled(Form)`
  .appointment-types {
    display: flex;
    flex-direction: column;
    padding-right: 8px;
    padding-left: 8px;
    margin-top: 30px;
  }

  .field-holder {
    margin-bottom: 0 !important;
  }

  .appointments-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex-wrap: wrap;
  }

  button {
    align-self: start;
  }

  .mt-20 {
    margin-top: 20px;
  }
`;

export const ProductsListStyles = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  padding-bottom: 50px;
`;
